import React from 'react'

import { Box, Grid, Step, Button } from '@mui/material'
import { GridStepper } from '@front/squirtle'
import { I18n } from '@front/volcanion'

import FormHeader, { Actions } from '@abra/elements/headers/Form'
import GroupTab from '@abra/panels/Tab/Group'

import PrimarySection from './Section/Primary'
import OptionsSection from './Section/Options'
import HistorySection from './Section/History'
import Popup from './Popup'

const Vehicle = ({ isManagingRecord, group_id, openDialog, canTransfer }) =>
  <>
    <Popup />
    <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
      <Grid container rowSpacing={3}>
        <Grid hidden={!group_id} size={12}> <GroupTab value={3} /> </Grid>
        <Grid size={12}>
          <FormHeader>
            {canTransfer && (
              <Actions>
                <Button variant='contained' onClick={() => openDialog('transfer_vehicle_popup')} >
                  {I18n.t('vehicle.transfer')}
                </Button>
              </Actions>
            )}
          </FormHeader>
        </Grid>
        <Grid size={12}>
          <GridStepper groupsCount={[3]} activeStep={0} orientation="vertical" getStepProps={index => ({ active: index !== 2 || !!isManagingRecord })}>
            <Step> <PrimarySection /> </Step>
            <Step> <OptionsSection /> </Step>
            <Step> <HistorySection disabled={!isManagingRecord} /> </Step>
          </GridStepper>
        </Grid>
      </Grid>
    </Box>
  </>

export default React.memo(Vehicle)
